// extracted by mini-css-extract-plugin
module.exports = {"button":"SettingsPaymentDetails_button__a7b4E"};